import { useMutation } from 'react-query'
import { useSearchParams } from 'react-router-dom'

import { userService } from 'src/services/user.service'
import { IChangeUserPasswordDto } from 'src/types'

const useChangeUserPassword = () => {
  const [, setSearchParams] = useSearchParams()

  return useMutation((dto: IChangeUserPasswordDto) => userService.changePassword(dto), {
    onSuccess(data) {
      if (!data) return

      setSearchParams((params) => {
        params.set('change_password_token', data.change_password_token)
        return params
      })
    },
  })
}

export { useChangeUserPassword }
